import { DappIcon, DocsIcon, LogoIcon, MondayTradeIcon } from '@/assets';
import ThemeToggle from '@/components/ThemeToggle';
import { DAPP_URL, DOCS_URL } from '@/constants';
import { twc } from 'react-twc';

export default function Header() {
  return (
    <header className="border-b border-border-light-line-1 bg-solid-nav-bar sticky top-0 z-10 h-[60px] px-5">
      <div className="flex items-center justify-between h-full">
        <div className="flex items-center gap-1">
          <LogoIcon /> <MondayTradeIcon className="[&_path]:fill-text-black" />
        </div>
        <div className="flex items-center gap-4">
          <Button onClick={() => window.open(DAPP_URL, '_blank')}>
            <DappIcon />
            <span>DApp</span>
          </Button>
          <Button onClick={() => window.open(DOCS_URL, '_blank')}>
            <DocsIcon />
            <span>Docs</span>
          </Button>
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}

const Button = twc.button`h-8 px-3 flex items-center gap-1 bg-transparent border border-solid border-border-light-line-1 rounded-md text-xs font-normal text-text-black [&_path]:fill-text-black cursor-pointer hover:opacity-80`;
